import * as React from 'react';

import ATextInputV4 from './aTextInputV4.jsx';

class ACoolTextInputV4 extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[aCoolTextInputV4.jsx] ";
    }

    render() {
        console.log(this.componentName + 'render');

        let componentClass = 'bg-success';

        return (
            <div className='bg-success'>
                <ATextInputV4
                    // componentClass="coolComponet"
                    labelClass="coolLabel"
                    {... this.props} />
            </div>
        );
    }
}


export default ACoolTextInputV4;